<template>
    <b-modal :id="id" title="Ajukan Barang Hilang" :no-close-on-backdrop="isSubmitting" :no-close-on-esc="isSubmitting"
        :hide-header-close="isSubmitting" @show="reset">
        <b-form :id="id + '-form'" @submit.prevent="submit">
            <div class="form-content-wrapper mb-0">
                <h6 class="form-title">FOTO PENDUKUNG</h6>
                <b-button variant="pgiBtn" class="mb-2" @click="addFotoPendukung"><i class="fa fa-plus mr-2"></i>Foto Pendukung</b-button>
                <div class="text-danger mt-2 mb-2" v-show="fotoPendukungError">* Foto Pendukung Maksimal {{ input.fotoPendukung.length }} Foto</div>
                <FotoPendukung v-for="item in input.fotoPendukung" :key="item.index" :fotoPendukung="item"
                    :length="input.fotoPendukung.length" :minLength="1"
                    @remove="removeFotoPendukung" @showModalCam="openModalCam"
                    @showModalPreview="openModalPreview" :lat="lat" :long="long" isRemove />
            </div>
            <div class="form-content-wrapper mt-4 mb-0">
                <b-form-group label="Keterangan" class="mb-0">
                    <b-form-textarea v-model="input.keterangan" name="keterangan" rows="3" maxlength="250" required />
                </b-form-group>
                <b-form-group label="Polsek" class="mt-4">
                    <b-form-input v-model="input.polsek" name="polsek" maxlength="50" />
                </b-form-group>
                <b-form-group label="Perihal" class="mt-4">
                    <multiselect v-model="input.perihal" :options="perihalOpt" :internal-search="true"
                    :allow-empty="false" deselect-label="" select-label="" label="name" track-by="id"
                    placeholder="-- Please select an option --" />
                </b-form-group>
                <b-form-group label="Tanggal Kejadian" class="mt-4">
                    <b-form-input type="date" v-model="input.tanggalKejadian" name="tglKejadian" />
                </b-form-group>
            </div>
        </b-form>
        <template v-slot:modal-footer="{ cancel }">
            <b-button variant="secondary" :disabled="isSubmitting" @click="cancel()">
                Cancel
            </b-button>
            <b-button variant="pgiBtn" :disabled="isSubmitting" type="submit" :form="id + '-form'">
                <b-spinner small type="grow" v-if="isSubmitting"></b-spinner>
                {{isSubmitting ? 'Memproses...' : 'Ajukan Barang Hilang'}}
            </b-button>
        </template>
        <ModalWebCam :idWebcam="id + '-webcam'" @photoTaken="setResult" />
        <ModalPreview :modalId="id + '-preview'" :fotoPreview="activeFotoPreview" />
    </b-modal>
</template>

<script>
import FotoPendukung from '@/components/webcam/FotoPendukung'
import ModalWebCam from '@/components/webcam/ModalWebCam'
import ModalPreview from '@/components/webcam/ModalPreview'

export default {
    name: 'ModalAjukanBarangHilang',
    components: { FotoPendukung, ModalWebCam, ModalPreview },
    props: {
        id: { type: String, required: true },
        gadaiId: { type: [Number, String], default: null },
    },
    data() {
        return {
            isSubmitting: false,
            perihalOpt: [],
            input: { fotoPendukung: [] },
            indexFotoPendukung: 0,
            fotoPendukungError: false,
            activeFotoPendukungIndex: null,
            activeFotoPreview: "",
            lat: 0,
            long: 0,
        }
    },
    methods: {
        reset() {
            this.input = {
                keterangan: "",
                polsek: "",
                perihal: null,
                tanggalKejadian: null,
                fotoPendukung: [],
            }
            this.fotoPendukungError = false
            this.addFotoPendukung()
            navigator.geolocation.getCurrentPosition(position => {
                this.lat = position.coords.latitude
                this.long = position.coords.longitude
            }, error => console.log(error.message))
            if (this.perihalOpt.length == 0) {
                this.$axios.get("/perihal/?type=1&isActive=true").then(response => {
                    this.perihalOpt = response.data
                })
                .catch(error => this.$helper.parseError(this, error))
            }
        },

        newFotoPendukung() {
            return {
                id: 0,
                index: this.indexFotoPendukung++,
                checkFotoBarangPendukung: false,
                fotoBarangPendukungPlaceholder: 'Choose a file',
                fotoBarangPendukung: null,
                fotoBarangPendukungBase64: null,
                activeFotoPendukungBase64: null,
            }
        },

        addFotoPendukung() {
            if (this.input.fotoPendukung.length >= 30) {
                this.fotoPendukungError = true
                return
            }
            this.input.fotoPendukung.unshift(this.newFotoPendukung())
        },

        removeFotoPendukung(index) {
            this.input.fotoPendukung = this.input.fotoPendukung.filter(item => item.index != index)
            this.fotoPendukungError = false
        },

        openModalCam(index) {
            this.activeFotoPendukungIndex = index
            this.$bvModal.show(this.id + '-webcam')
        },

        openModalPreview(index) {
            const item = this.input.fotoPendukung.find(item => item.index == index)
            this.activeFotoPreview = item.activeFotoPendukungBase64
            this.$bvModal.show(this.id + '-preview')
        },

        async setResult(result) {
            const formattedDate = this.$helper.formatTanggalDMY()
            const waktu = this.$helper.waktu24()
            try {
                const img = new Image()
                const resized = await this.$helper.resizeImage(result)
                await new Promise((resolve, reject) => {
                    img.onload = resolve
                    img.onerror = reject
                    img.src = resized
                })
                const canvas = document.createElement('canvas')
                const ctx = canvas.getContext('2d')
                canvas.width = img.width
                canvas.height = img.height
                ctx.drawImage(img, 0, 0)
                ctx.font = "14pt Arial"
                ctx.fillStyle = "#ffffff"
                ctx.fillText(formattedDate + ' ' + waktu, 10, img.height - 40)
                ctx.strokeText(formattedDate + ' ' + waktu, 10, img.height - 40)
                ctx.fillText(this.lat + ' ' + this.long, 10, img.height - 10)
                ctx.strokeText(this.lat + ' ' + this.long, 10, img.height - 10)
                const base64 = canvas.toDataURL('image/jpeg', 0.9)

                const item = this.input.fotoPendukung.find(item => item.index == this.activeFotoPendukungIndex)
                item.fotoBarangPendukungBase64 = base64
                item.activeFotoPendukungBase64 = base64
                item.fotoBarangPendukungPlaceholder = "Foto dari Kamera"
                item.checkFotoBarangPendukung = true
            } catch (error) {
                console.log(error)
                this.$helper.toastErr(this, "Gagal memproses gambar, silahkan coba kembali!")
            }
        },

        submit() {
            if (this.input.fotoPendukung.length == 0) return this.$helper.toastErr(this, "Mohon upload minimal 1 gambar!")
            if (this.input.fotoPendukung.some(item => this.$helper.isNullOrEmpty(item.activeFotoPendukungBase64))) return this.$helper.toastErr(this, "Terdapat upload gambar yang kosong, periksa kembali!")
            const foto = this.input.fotoPendukung.map(item => item.activeFotoPendukungBase64)
            if (this.$helper.isNullOrEmpty(this.input.keterangan.trim())) return this.$helper.toastErr(this, "Wajib isi Keterangan terlebih dahulu!")
            if (this.$helper.isNullOrEmpty(this.input.polsek.trim())) return this.$helper.toastErr(this, "Wajib isi polsek terlebih dahulu!")
            if (this.input.perihal == null) return this.$helper.toastErr(this, "Wajib pilih perihal terlebih dahulu!")
            if (this.$helper.isNullOrEmpty(this.input.tanggalKejadian)) return this.$helper.toastErr(this, "Wajib isi Tanggal Kejadian terlebih dahulu!")

            const payload = {
                gadaiId: this.gadaiId,
                keterangan: this.input.keterangan.trim(),
                polsek: this.input.polsek.trim(),
                perihalId: this.input.perihal.id,
                tanggalKejadian: this.input.tanggalKejadian,
                foto: JSON.stringify(foto),
            }

            this.isSubmitting = true
            this.$axios.post("gadai-hilang/pengajuan/", payload).then(() => {
                this.$helper.toastSucc(this, "Pengajuan barang hilang berhasil dilakukan")
                this.$bvModal.hide(this.id)
                this.$emit("submitted")
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => {
                this.isSubmitting = false
            })
        },
    },
}
</script>
